import { type ReactNode, useState } from 'react';
import { Fade } from '@/components/ui/fade';
import { useCreatorsState } from '../hooks/use-creators-state';
import { CreatorsFilters } from './creators-filters';
import { CreatorsContent } from './creators-content';
import { CreatorDetailModal } from './creator-detail-modal';

export function CreatorsPage(): ReactNode {
  const { state, data, isFetching, isPlaceholderData } = useCreatorsState();
  const [selectedId, setSelectedId] = useState<string | null>(null);

  return (
    <div className="space-y-lg">
      <CreatorsFilters />
      <Fade activeKey={state}>
        <CreatorsContent
          state={state}
          data={data}
          isFetching={isFetching && isPlaceholderData}
          onSelect={setSelectedId}
        />
      </Fade>
      <CreatorDetailModal
        leadId={selectedId}
        onClose={() => setSelectedId(null)}
      />
    </div>
  );
}
